<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header gap-3">
      <div class="modal-title">
        <ng-container *ngIf="groupRentalId | rentalChildren : groupType | async; let children">
          <app-rental-name
            [rentalId]="data.rentalId"
            [image]="true"
            [imageSize]="35"
            *ngIf="!children.length"
          ></app-rental-name>
          <app-rental-group-select
            [groupId]="groupRentalId"
            [groupType]="groupType"
            [ctrl]="selectedRentalCtrl"
            *ngIf="children.length"
          ></app-rental-group-select>
        </ng-container>
      </div>
      <div class="flex-fill"></div>
      <ng-container *ngIf="tab$.value === tabs.Calendar && !(rental | isSubunit)">
        <button
          [disabled]="1 | isReadonlyRole"
          i18n-matTooltip
          matTooltip="This button will enable users to quickly define a fixed rate for selected dates within the calendar view."
          matTooltipPosition="below"
          type="button"
          class="btn btn-secondary-danger"
          (click)="onAddStandardRate()"
        >
          <span class="cs-icon cs-icon-dollar"></span> <ng-container i18n>Add Standard Rate</ng-container>
        </button>
        <button
          [disabled]="1 | isReadonlyRole"
          i18n-matTooltip
          matTooltip="This button will provide users with the option to apply dynamic pricing rules for the selected dates."
          matTooltipPosition="below"
          type="button"
          class="btn btn-secondary-primary"
          (click)="onAddDynamicRate()"
        >
          <span class="cs-icon cs-icon-dollar-sync"></span> <ng-container i18n>Add Dynamic Rate</ng-container>
        </button>
      </ng-container>
      <ng-container *ngIf="tab$.value === tabs.Basic">
        <button
          [disabled]="1 | isReadonlyRole"
          i18n-matTooltip
          matTooltip="A Rental can be deleted only when all associated hold events and inquiries/bookings have been deleted."
          matTooltipPosition="below"
          (click)="basic?.onDelete()"
          type="button"
          class="btn btn-secondary-danger"
        >
          <span class="cs-icon cs-icon-trash"></span> <ng-container i18n>Delete</ng-container>
        </button>
        <app-button
          (click)="basic?.save()"
          icon="cs-icon cs-icon-save"
          [class]="'success' | buttonClass"
          [disabled]="1 | isReadonlyRole"
          [loading]="basic?.isSaving$ | async"
        >
          <ng-container i18n>Save</ng-container>
        </app-button>
      </ng-container>
      <app-button
        *ngIf="tab$.value === tabs.Info"
        (click)="detail?.save()"
        icon="cs-icon cs-icon-save"
        [class]="'success' | buttonClass"
        [disabled]="1 | isReadonlyRole"
        [loading]="detail?.isSavingDetailInfo$ | async"
      >
        <ng-container i18n>Save</ng-container>
      </app-button>
      <app-button
        *ngIf="tab$.value === tabs.Gallery"
        (click)="gallery?.onUpload()"
        icon="fal fa-upload"
        [disabled]="1 | isReadonlyRole"
        [class]="'success' | buttonClass"
      >
        <ng-container i18n>Upload</ng-container>
      </app-button>
      <ng-container *ngIf="tab$.value === tabs.Instructions">
        <button
          (click)="instructions?.copy()"
          matTooltip="Click here to copy Instructions, Rules, Terms or Directions from any other rental."
          matTooltipPosition="below"
          i18n-matTooltip
          class="btn btn-secondary-primary"
          [disabled]="1 | isReadonlyRole"
        >
          <i class="fal fa-copy"></i>
          <ng-container i18n>Copy Terms</ng-container>
        </button>
        <app-button
          (click)="instructions.save()"
          icon="cs-icon cs-icon-save"
          [class]="'success' | buttonClass"
          [disabled]="1 | isReadonlyRole"
          [loading]="instructions?.isSaving$ | async"
        >
          <ng-container i18n>Save</ng-container>
        </app-button>
      </ng-container>
      <app-button
        (click)="multiUnit?.save()"
        *ngIf="tab$.value === tabs.MultiUnitSettings"
        icon="cs-icon cs-icon-save"
        [class]="'success' | buttonClass"
        [disabled]="1 | isReadonlyRole"
        [loading]="isSaving$ | async"
      >
        <ng-container i18n>Save</ng-container>
      </app-button>
      <app-button
        (click)="custom?.save()"
        *ngIf="tab$.value === tabs.Custom"
        icon="cs-icon cs-icon-save"
        [class]="'success' | buttonClass"
        [disabled]="1 | isReadonlyRole"
        [loading]="custom?.isSavingCustom$ | async"
      >
        <ng-container i18n>Save</ng-container>
      </app-button>
      <app-button
        (click)="location?.save()"
        *ngIf="tab$.value === tabs.Location"
        icon="cs-icon cs-icon-save"
        [class]="'success' | buttonClass"
        [disabled]="1 | isReadonlyRole"
        [loading]="location?.isSaving$ | async"
      >
        <ng-container i18n>Save</ng-container>
      </app-button>
      <app-button
        (click)="compliance?.save()"
        *ngIf="showCompliance && tab$.value === tabs.Compliance"
        icon="cs-icon cs-icon-save"
        [class]="'success' | buttonClass"
        [disabled]="1 | isReadonlyRole"
        [loading]="compliance?.isSaving$ | async"
      >
        <ng-container i18n>Save</ng-container>
      </app-button>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>

    <ul class="nav top-navbar bg-white border-bottom" role="tablist">
      <li
        [class.active]="tab$.value === tabs.Calendar"
        i18n-matTooltip
        matTooltip="View the dates booked on your rental."
        matTooltipPosition="below"
      >
        <a href="javascript:;" (click)="tab$.next(tabs.Calendar)"> <ng-container i18n>Calendar</ng-container> </a>
      </li>
      <li
        *ngIf="!isChidUnitRental"
        dropdown
        class="dropdown"
        container="body"
        [class.active]="
          tab$.value === tabs.RatesTable || tab$.value === tabs.RateMappings || tab$.value === tabs.Settings
        "
        [matTooltip]="
          hasIncompleteBaseRate ? incompleteBaseRateMessage : 'Adjust the Base Rate settings for your rental.'
        "
        matTooltipPosition="below"
      >
        <a href="javascript:;" dropdownToggle class="dropdown-toggle">
          <ng-container i18n>Rates</ng-container>
          <i *ngIf="hasIncompleteBaseRate" class="fal fa-exclamation-triangle text-danger"></i>
        </a>
        <ul *dropdownMenu class="dropdown-menu">
          <li>
            <button (click)="tab$.next(tabs.RatesTable)" [class.active]="tab$.value === tabs.RatesTable" type="button">
              <ng-container i18n>Rates Table</ng-container>
            </button>
          </li>
          <li>
            <button
              (click)="tab$.next(tabs.RateMappings)"
              [class.active]="tab$.value === tabs.RateMappings"
              type="button"
            >
              <ng-container i18n>Rate Mappings</ng-container>
            </button>
          </li>
          <li>
            <button (click)="onSmartRates()" type="button">
              <ng-container i18n>Smart Rate Automation</ng-container>
            </button>
          </li>
          <li>
            <button
              (click)="tab$.next(tabs.Settings)"
              [class.active]="tab$.value === tabs.Settings"
              type="button"
              [matTooltip]="hasIncompleteBaseRate ? incompleteBaseRateMessage : ''"
              matTooltipPosition="left"
            >
              <ng-container i18n>Settings</ng-container>
              <i *ngIf="hasIncompleteBaseRate" class="fal fa-exclamation-triangle text-danger"></i>
            </button>
          </li>
        </ul>
      </li>
      <li
        [class.active]="tab$.value === tabs.Basic"
        i18n-matTooltip
        matTooltip="Set name, address and other basic information of rental."
        matTooltipPosition="below"
      >
        <a href="javascript:;" (click)="tab$.next(tabs.Basic)"> <ng-container i18n>Basic Information</ng-container> </a>
      </li>
      <li
        matTooltip="Specify amenities and other rental values."
        i18n-matTooltip
        matTooltipPosition="below"
        [class.active]="tab$.value === tabs.Info"
      >
        <a href="javascript:;" (click)="tab$.next(tabs.Info)"> <ng-container i18n>Detail Information</ng-container> </a>
      </li>
      <li
        matTooltip="Upload images or view images imported from listing channels."
        i18n-matTooltip
        matTooltipPosition="below"
        [class.active]="tab$.value === tabs.Gallery"
      >
        <a href="javascript:;" (click)="tab$.next(tabs.Gallery)"> <ng-container i18n>Gallery</ng-container> </a>
      </li>
      <li
        [matTooltip]="instructionsTooltip"
        i18n-matTooltip
        matTooltipPosition="below"
        [class.active]="tab$.value === tabs.Instructions"
      >
        <a href="javascript:;" (click)="tab$.next(tabs.Instructions)">
          <ng-container i18n>Rental Instructions</ng-container>
          <i *ngIf="hasIncompleteCheckInOut || isCheckoutInstructionMissing" class="fal fa-exclamation-triangle"></i>
        </a>
      </li>
      <li
        matTooltipPosition="below"
        *ngIf="rental?.multi_unit_id == rental?.id && !(isFreePlan$ | async)"
        [class.active]="tab$.value === tabs.MultiUnitSettings"
      >
        <a href="javascript:;" (click)="tab$.next(tabs.MultiUnitSettings)">
          <ng-container i18n>Multi-Unit Settings</ng-container>
        </a>
      </li>
      <li
        matTooltip="Add rental specific data for use with message templates."
        i18n-matTooltip
        matTooltipPosition="below"
        [class.active]="tab$.value === tabs.Custom"
      >
        <a href="javascript:;" (click)="tab$.next(tabs.Custom)">
          <ng-container i18n>Custom Information</ng-container>
        </a>
      </li>
      <ng-container *ngIf="!isChidUnitRental">
        <li
          *ngIf="showCompliance"
          matTooltip="Manage compliance integrations and guest registration"
          i18n-matTooltip
          matTooltipPosition="below"
          [class.active]="tab$.value === tabs.Compliance"
        >
          <a href="javascript:;" (click)="tab$.next(tabs.Compliance)">
            <ng-container i18n>Compliance</ng-container>
          </a>
        </li>
        <li
          matTooltip="Set and view location of this rental on map"
          matTooltipPosition="below"
          i18n-matTooltip
          [class.active]="tab$.value === tabs.Location"
        >
          <a href="javascript:;" (click)="tab$.next(tabs.Location)"> <ng-container i18n>Location</ng-container> </a>
        </li>
        <li
          matTooltip="Add unique/custom fields in any of the sections"
          i18n-matTooltip
          matTooltipPosition="below"
          [class.active]="tab$.value === tabs.Attributes"
        >
          <a href="javascript:;" (click)="tab$.next(tabs.Attributes)">
            <ng-container i18n>Custom Attributes</ng-container>
          </a>
        </li>
      </ng-container>
    </ul>

    <ul class="nav drawer-right-navbar">
      <ng-container *ngIf="!isChidUnitRental">
        <li [class.active]="tab$.value === tabs.Taxes" i18n-matTooltip matTooltip="Tax / VAT" matTooltipPosition="left">
          <a (click)="tab$.next(tabs.Taxes)">
            <i class="fal fa-hand-holding-usd"></i>
          </a>
        </li>
        <li [class.active]="tab$.value === tabs.Fees" i18n-matTooltip matTooltip="Fees" matTooltipPosition="left">
          <a (click)="tab$.next(tabs.Fees)">
            <i class="fal fa-money-bill"></i>
          </a>
        </li>
        <li
          [class.active]="tab$.value === tabs.SecurityDeposit"
          i18n-matTooltip
          matTooltip="Automatic Security Deposit"
          matTooltipPosition="left"
        >
          <a (click)="tab$.next(tabs.SecurityDeposit)">
            <i class="fal fa-shield-check"></i>
          </a>
        </li>
        <li
          [class.active]="tab$.value === tabs.PaymentSchedule"
          i18n-matTooltip
          matTooltip="Payment Schedule"
          matTooltipPosition="left"
        >
          <a (click)="tab$.next(tabs.PaymentSchedule)">
            <i class="fal fa-badge-percent"></i>
          </a>
        </li>
      </ng-container>
      <li [class.active]="tab$.value === tabs.Rooms" i18n-matTooltip matTooltip="Rooms" matTooltipPosition="left">
        <a (click)="tab$.next(tabs.Rooms)">
          <i class="fal fa-bed"></i>
        </a>
      </li>
      <li
        [class.active]="tab$.value === tabs.UserRestrictions"
        *ngIf="!(isRestrictingUsers$ | async) && !isChidUnitRental"
        matTooltip="User Restrictions"
        i18n-matTooltip
        matTooltipPosition="left"
      >
        <a (click)="tab$.next(tabs.UserRestrictions)">
          <i class="fal fa-user-lock"></i>
        </a>
      </li>
      <li
        [class.active]="tab$.value === tabs.OwnerAccess"
        i18n-matTooltip
        matTooltip="Owner Access"
        matTooltipPosition="left"
      >
        <a (click)="tab$.next(tabs.OwnerAccess)">
          <i class="fal fa-user-shield"></i>
        </a>
      </li>
      <li [class.active]="tab$.value === tabs.Tags" i18n-matTooltip matTooltip="Manage Tags" matTooltipPosition="left">
        <a (click)="tab$.next(tabs.Tags)">
          <i class="fal fa-tags"></i>
        </a>
      </li>
      <li
        [class.active]="tab$.value === tabs.Connections"
        i18n-matTooltip
        matTooltip="Connections"
        matTooltipPosition="left"
        *ngIf="!isChidUnitRental"
      >
        <a (click)="tab$.next(tabs.Connections)">
          <i class="cs-icon cs-icon-links-cog"></i>
        </a>
      </li>
      <li
        [class.active]="tab$.value === tabs.Calendars"
        i18n-matTooltip
        matTooltip="Calendars"
        matTooltipPosition="left"
        *ngIf="!isChidUnitRental"
      >
        <a (click)="tab$.next(tabs.Calendars)">
          <i class="cs-icon cs-icon-calendar-link"></i>
        </a>
      </li>
      <li
        [class.active]="tab$.value === tabs.CheckinRules"
        i18n-matTooltip
        matTooltip="Check-in / Check-out Rules"
        matTooltipPosition="left"
        *ngIf="!isChidUnitRental"
      >
        <a (click)="tab$.next(tabs.CheckinRules)">
          <i class="fal fa-calendar-times"></i>
        </a>
      </li>
      <li
        [class.active]="tab$.value === tabs.Documents"
        i18n-matTooltip
        matTooltip="Documents"
        matTooltipPosition="left"
        *ngIf="!isChidUnitRental"
      >
        <a (click)="tab$.next(tabs.Documents)">
          <i class="cs-icon cs-icon-documents2"></i>
        </a>
      </li>
    </ul>
    <div class="modal-body">
      <div *ngIf="rental" class="tab-content">
        <section [ngSwitch]="tab$.value" class="rental-settings-page">
          <app-rental-rates-calendar
            #calendar
            *ngSwitchCase="tabs.Calendar"
            [rental]="rental"
            [showEvents]="true"
          ></app-rental-rates-calendar>

          <app-rental-details-basic-info
            #basic
            *ngSwitchCase="tabs.Basic"
            [rental]="rental"
          ></app-rental-details-basic-info>
          <app-rental-details-detail-info
            #detail
            *ngSwitchCase="tabs.Info"
            [rental]="rental"
          ></app-rental-details-detail-info>
          <app-rental-details-image-gallery
            #gallery
            *ngSwitchCase="tabs.Gallery"
            [rental]="rental"
            [highlightedItems]="data.highlightedImages"
          ></app-rental-details-image-gallery>

          <app-rental-details-instructions
            #instructions
            *ngSwitchCase="tabs.Instructions"
            [rental]="rental"
          ></app-rental-details-instructions>
          <app-rental-details-custom-info
            #custom
            *ngSwitchCase="tabs.Custom"
            [rental]="rental"
          ></app-rental-details-custom-info>
          <app-rental-multi-unit-settings
            #multiUnit
            *ngSwitchCase="tabs.MultiUnitSettings"
            [rental]="rental"
          ></app-rental-multi-unit-settings>

          <app-rental-location #location *ngSwitchCase="tabs.Location" [rental]="rental"></app-rental-location>
          <ng-container *ngSwitchCase="tabs.Compliance">
            <app-rental-compliance #compliance [rental]="rental" *ngIf="showCompliance"></app-rental-compliance>
          </ng-container>
          <div class="bg-white p-3 rounded-bottom" *ngSwitchCase="tabs.Attributes">
            <app-entity-attributes
              #attrs
              entityType="rental"
              [entityId]="rental.id"
              [showActions]="true"
            ></app-entity-attributes>
          </div>
          <app-edit-rental-taxes *ngSwitchCase="tabs.Taxes" [rental]="rental"></app-edit-rental-taxes>
          <app-rental-rooms *ngSwitchCase="tabs.Rooms" [rental]="rental"></app-rental-rooms>
          <app-rental-payment-schedule
            *ngSwitchCase="tabs.PaymentSchedule"
            [rental]="rental"
          ></app-rental-payment-schedule>
          <app-rental-fees *ngSwitchCase="tabs.Fees" [rental]="rental"></app-rental-fees>
          <app-rental-security-deposit
            *ngSwitchCase="tabs.SecurityDeposit"
            [rental]="rental"
          ></app-rental-security-deposit>
          <app-rental-user-restrictions
            *ngSwitchCase="tabs.UserRestrictions"
            [rental]="rental"
          ></app-rental-user-restrictions>
          <app-rental-owner-access *ngSwitchCase="tabs.OwnerAccess" [rental]="rental"></app-rental-owner-access>
          <app-rental-tags *ngSwitchCase="tabs.Tags" [rental]="rental"></app-rental-tags>
          <app-rental-connections *ngSwitchCase="tabs.Connections" [rental]="rental"></app-rental-connections>
          <app-rental-calendars *ngSwitchCase="tabs.Calendars" [rental]="rental"></app-rental-calendars>
          <app-rental-rates-table
            class="container-box d-block"
            [rental]="rental"
            *ngSwitchCase="tabs.RatesTable"
          ></app-rental-rates-table>
          <app-rental-rate-mappings-table
            class="container-box d-block"
            [defaultRental]="rental"
            *ngSwitchCase="tabs.RateMappings"
          ></app-rental-rate-mappings-table>
          <app-rental-rate-settings
            class="container-box d-block"
            [rental]="rental"
            *ngSwitchCase="tabs.Settings"
          ></app-rental-rate-settings>
          <app-discounts-table
            class="container-box d-block"
            *ngSwitchCase="tabs.Discounts"
            [showAddBtn]="true"
            [rental]="rental"
          >
          </app-discounts-table>
          <app-rental-docs *ngSwitchCase="tabs.Documents" [rental]="rental"></app-rental-docs>
          <app-rental-checkin-rules *ngSwitchCase="tabs.CheckinRules" [rental]="rental"></app-rental-checkin-rules>
        </section>
      </div>
    </div>
  </div>
</div>
